import React from "react";
import { Redirect } from "react-router-dom";

/**
 * Builds a React Router redirect component.
 */
export const AppRedirect = ({ from, to, render }) => {
  const key = "redirect-" + to.replace("/", "-").toLowerCase();

  return <Redirect from={from} to={to} render={render} key={key} />;
};

export default AppRedirect;
